import {
    BODY_LG_LG_BOLD_STYLES,
    BODY_MD_MD_STYLES,
    BODY_SM_SM_BOLD_STYLES,
    BODY_SM_SM_STYLES,
    HEADING_XXS_STYLES,
} from '@constants/text.ts';
import styled from 'styled-components';

export const PointsToastWrapper = styled.div`
    display: flex;
    gap: 16px;
`;

export const InfoSection = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Title = styled.div`
    color: var(--colors-text-body, #50566e);
    ${HEADING_XXS_STYLES};
`;

export const PointsToastDescription = styled.div`
    color: var(--colors-text-body, #50566e);
    ${BODY_SM_SM_STYLES};
`;

export const Description = styled.div`
    color: var(--colors-text-body, #50566e);
    ${BODY_MD_MD_STYLES};
`;

export const PointsPill = styled.div<{ $isBonus: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 14px;
    gap: 4px;
    border-radius: var(--border-radius-round, 48px);
    background: ${({ $isBonus }) => ($isBonus ? 'var(--Warning-default, #EB9D06)' : 'var(--Secondary-300, #7DC8CD)')};
    height: 32px;
    margin-top: 4px;
`;

export const Points = styled.div`
    color: var(--colors-text-on-action, #fff);
    ${BODY_SM_SM_BOLD_STYLES};
    margin-top: 2px;
`;

export const ToastWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    svg {
        align-self: baseline;
    }
`;

export const ToastInnerWrapperNoTitle = styled.div`
    display: flex;
    align-items: center;
    gap: var(--spacing-xs, 8px);
`;

export const ToastInnerWrapperTitle = styled.div`
    display: flex;
    flex-direction: column;
`;

export const IconWithTitle = styled.div`
    display: flex;
    align-items: center;
    gap: var(--spacing-xs, 8px);
    color: var(--colors-text-headings, #3e445c);
    ${BODY_LG_LG_BOLD_STYLES};
    margin-bottom: 8px;
`;
